export const DELETE_STATEMENT_TEMPLATE_FAILURE = 'DELETE_STATEMENT_TEMPLATE_FAILURE';

export const deleteStatementTemplateFailure = error => ({
    type: DELETE_STATEMENT_TEMPLATE_FAILURE,
    payload: error,
    error: true,
});
